import CreditDebitNotesPage from "./CreditDebitNotesPage";

export default CreditDebitNotesPage;
